// extracted by mini-css-extract-plugin
module.exports = {"check":"GreenCheckmark_check__2kzrD"};